import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { styled } from '../../stitches.config.js';
import { Text } from '../Text/Text.js';
import { Box } from '../Box/Box.js';

var Content = styled(TooltipPrimitive.Content, {
  color: '$tooltipText',
  backgroundColor: '$tooltipContentBg',
  borderRadius: '$3',
  padding: '$2',
  variants: {
    multiline: {
      true: {
        maxWidth: 250,
        pb: 7
      }
    }
  }
});
var ArrowBox = styled(Box, {
  color: '$tooltipContentBg'
});
function Tooltip(_a) {
  var children = _a.children,
    content = _a.content,
    open = _a.open,
    defaultOpen = _a.defaultOpen,
    onOpenChange = _a.onOpenChange,
    multiline = _a.multiline,
    css = _a.css,
    props = __rest(_a, ["children", "content", "open", "defaultOpen", "onOpenChange", "multiline", "css"]);
  var isContentString = React.useMemo(function () {
    return typeof content === 'string';
  }, [content]);
  return /*#__PURE__*/React.createElement(TooltipPrimitive.Root, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Trigger, {
    asChild: true
  }, children), /*#__PURE__*/React.createElement(Content, __assign({
    css: css,
    side: "top",
    align: "center",
    sideOffset: 5
  }, props, {
    multiline: multiline
  }), isContentString ? /*#__PURE__*/React.createElement(Text, {
    size: "1",
    as: "p",
    css: {
      color: 'currentColor',
      lineHeight: multiline ? '20px' : undefined
    }
  }, content) : content, /*#__PURE__*/React.createElement(ArrowBox, null, /*#__PURE__*/React.createElement(TooltipPrimitive.Arrow, {
    offset: 5,
    width: 11,
    height: 5,
    style: {
      fill: 'currentColor'
    }
  }))));
}

export { Tooltip };
